import React from "react";
import { uploadImageIcon, PeopleIcon, iconKWhite } from "assets/icons"; // Import placeholder image
import { useTranslation } from "react-i18next";
import { FiltersDropdown } from "reusableComponents";
import { eyeIcon } from "assets/icons";
import { lastMinuteIconRed } from "assets/icons/badges";

import styles from "./styles.module.scss";

const ProviderSpaceCard = ({
  onStatusChange,
  imageUrl,
  name,
  last_step,
  spaceCategory,
  status,
  maxCapacity,
  onEdit,
  onEditOptions = () => {},
  onViewSpace = () => {},
  onDelete,
  isSpacePrivate,
  isLastMinute,
  isSpaceCompleted,
  isMinimalView = false,
  onClick, // New onClick prop
  placeId,
  isActive = false, // New prop to track active state
  lockAvailable = false, // New prop for lock availability
}) => {
  const { t } = useTranslation("global");

  const handleCardClick = (e) => {
    if (!onClick || !placeId) return;
    
    // Check if click originated from an interactive element
    const interactiveElements = [
      'button',
      'a',
      'input',
      'select',
      'textarea',
      '[role="button"]',
      `.${styles.eyeIcon}`,
    ].join(',');
    
    if (e.target.closest(interactiveElements)) {
      return;
    }
    
    onClick(placeId);
  };

  const statusOptions = [
    {
      value: true,
      label: t("dashboard.spacesManagement.offline"),
    },
    {
      value: false,
      label: t("dashboard.spacesManagement.online"),
    },
    {
      value: "lastMinute",
      label: t("dashboard.spacesManagement.lastMinute"),
    },
  ];

  const filteredStatusOptions = isLastMinute
    ? statusOptions.filter((option) => option.value !== false) // Remove "online" option
    : statusOptions;

  const getSelectedStatus = () => {
    if (isSpacePrivate) return true;
    if (!isSpacePrivate && isLastMinute) return "lastMinute";
    if (!isSpacePrivate && !isLastMinute) return false;
    return false; // Default fallback
  };

  return (
    <div
      className={`${styles.card} ${isActive ? styles.active : ''}`}
      onClick={handleCardClick}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      <div className={styles.cardContent}>
        <div
          className={styles.image}
          style={{
            backgroundImage: `url(${imageUrl || uploadImageIcon})`,
          }}
        />
        <div className={styles.info}>
          <p
            className={styles.category}
            style={{ backgroundColor: spaceCategory?.color || "#90abb1" }}
          >
            {spaceCategory
              ? spaceCategory.label
              : t("dashboard.spacesManagement.noCategory")}
          </p>
          <h3 className={styles.name}>{name}</h3>
          <div className={styles.capacityWrapper}>
            {maxCapacity > 0 && (
              <div className={styles.capacity}>
                <img
                  src={PeopleIcon}
                  alt="People icon"
                  className={styles.peopleIcon}
                />
                <p>{maxCapacity}</p>
              </div>
            )}
{lockAvailable && (
  <div className={styles.lockAvailable}>
    <svg 
      width="14" 
      height="14" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      style={{ color: 'var(--secondary-color)' }}
    >
      <path 
        d="M12 2C9.23858 2 7 4.23858 7 7V9H6C4.89543 9 4 9.89543 4 11V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V11C20 9.89543 19.1046 9 18 9H17V7C17 4.23858 14.7614 2 12 2ZM9 7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7V9H9V7Z" 
        fill="currentColor"
      />
      <path 
        d="M12 14C11.4477 14 11 14.4477 11 15V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V15C13 14.4477 12.5523 14 12 14Z" 
        fill="currentColor"
      />
    </svg>
    <span>{t("space.lockAvailable")}</span>
  </div>
)}
          </div>
        </div>
        <div className={styles.actions}>
          <div className={styles.buttons}>
            {!isMinimalView && (
              <>
                {" "}
                <button onClick={onEdit} className={styles.editButton}>
                  {t("dashboard.spacesManagement.edit")}
                </button>
                <button onClick={onEditOptions} className={styles.editButton}>
                  {t("dashboard.spacesManagement.manageOptions")}
                </button>
                <button onClick={onDelete} className={styles.deleteButton}>
                  {t("dashboard.spacesManagement.delete")}
                </button>
              </>
            )}
            {isSpaceCompleted && status === "approved" && (
              <button className={styles.eyeIcon} onClick={onViewSpace}>
                <img src={eyeIcon} alt={t("dashboard.messages.viewMessage")} />
              </button>
            )}
          </div>
          <div className={styles.statusHolder}>
            {status === "approved" ? (
              <FiltersDropdown
                selected={getSelectedStatus()}
                options={filteredStatusOptions}
                onSelect={(value) => onStatusChange(value)}
              />
            ) : (
              <p className={styles.status}>
                {status === "waiting"
                  ? t("dashboard.spacesManagement.pending")
                  : t("dashboard.spacesManagement.rejected")}
              </p>
            )}
            {!isMinimalView && (
              <img
                src={
                  isLastMinute && !isSpacePrivate
                    ? lastMinuteIconRed
                    : iconKWhite
                }
                alt="k icon"
                className={`${styles.statusIcon} ${styles[`${status}Icon`]} ${
                  isSpacePrivate ? styles.offlineIcon : ""
                } ${isLastMinute ? styles.lastMinuteIcon : ""}`}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProviderSpaceCard;